import { SEO } from '@/components/SEO';

export function CookiePolicyPage() {
  return (
    <>
      <SEO
        title="Cookie Policy - Nestor"
        description="Learn about how we use cookies and similar tracking technologies."
      />

      <div className="container mx-auto px-4 py-20 max-w-4xl">
        <h1 className="text-4xl font-bold mb-8">Cookie Policy</h1>
        <div className="prose prose-lg max-w-none space-y-6 text-muted-foreground">
          <p className="text-sm">Last updated: January 24, 2026</p>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">1. What Are Cookies?</h2>
            <p>
              Cookies are small text files that are placed on your device when you visit our website.
              They help us provide you with a better experience and allow certain features to work.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">2. Types of Cookies We Use</h2>
            
            <h3 className="text-xl font-semibold text-foreground mt-6 mb-3">Essential Cookies</h3>
            <p>
              These cookies are necessary for the website to function and cannot be switched off.
              They are usually set in response to actions made by you such as logging in.
            </p>

            <h3 className="text-xl font-semibold text-foreground mt-6 mb-3">Analytics Cookies</h3>
            <p>
              These cookies help us understand how visitors interact with our website by collecting
              and reporting information anonymously.
            </p>

            <h3 className="text-xl font-semibold text-foreground mt-6 mb-3">Marketing Cookies</h3>
            <p>
              These cookies track your online activity to help advertisers deliver more relevant advertising
              or to limit how many times you see an ad.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">3. Managing Cookies</h2>
            <p>
              You can control and/or delete cookies as you wish. You can delete all cookies that are
              already on your computer and you can set most browsers to prevent them from being placed.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">4. Third-Party Cookies</h2>
            <p>
              We use third-party services that may also set cookies on your device, including:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Google Analytics for website analytics</li>
              <li>Intercom for customer support</li>
              <li>LinkedIn and Twitter for social media integration</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">5. Contact</h2>
            <p>
              If you have questions about our use of cookies, contact us at privacy@hrms.com
            </p>
          </section>
        </div>
      </div>
    </>
  );
}
